module.exports = __webpack_public_path__ + "static/media/Logo_Website.ae00ecff.svg";